// extracted by mini-css-extract-plugin
module.exports = {"alertBox":"Settings_alertBox__NoO6j"};